import { useEffect, useRef } from "react";

export const M1_HR = () : React.JSX.Element => {
    const pref = useRef<HTMLParagraphElement>(null);
    const imgref = useRef<HTMLImageElement>(null);
    
    useEffect(() => {
        if(pref.current && imgref.current) {
            imgref.current.height = pref.current.clientHeight;
            imgref.current.width = pref.current.clientHeight*7.2;
        }
    }, [pref]);

    return(
        <>
            <p className="Indented">Današnjim tržištem informacijskih rješenja i sustava dominiraju sustavi upogonjeni umjetnom 
                inteligencijom (LLM). Zapanjujuća brzina kojom ovi modeli osvajaju tržište i korisnike ostavlja gotovo bez daha.
                Što će biti sljedeće ? Ovi modeli imaju odgovor na sva pitanja !? Činjenica jest da se u treniranju tih modela
                koriste ogromne količine tekstova i materijala, uključujući i sadržaj na Internetu. Korisnost tih modela je
                neosporna. No, isto tako je neosporno i da se moderne inteligentne tehnologije guraju na mala vrata u sve domene
                društva i poslovanja, često na pogrešan način i na krivom mjestu. Korisnici se s pravom pitaju kako uklopiti
                LLM ili nekakav model strojnog učenja u svoje svakodneno poslovanje. Tehnološki gledano načina je mnogo, od
                lokalnih fokusiranih modela, pa sve do agenata umjetne inteligencije (<i>agentic AI</i>). Identifikacija potrebe i
                mjesta u poslovnim procesima organizacije postaje od kritične važnosti za upotrebu umjetne inteligencije i modela
                strojnog učenja u svakodnevnom poslovanju.</p>
            <p className="NonIndented"><b>Misija Nove Inteligencije</b><br/>
                Svojim korisnicima ponuditi visoko kvalitetne kompleksne informacijske sustave koji počivaju na sljedećim
                premisama:
                <ul>                    
                    <li><b>Odgovarajuća arhitektura i infrastruktura</b> - Odabir arhitekture i infrastrukture koja odgovara organizaciji
                    i njenim informacijskim sustavima, s minimizacijom nepotrebih resursa i troškova, te smanjenjem potrebe za administracijom.
                    </li>
                    <li><b>Komunicirani dizajn</b> - Dizajn sustava koji je pravoremeno komuniciran i provjeren s korisnicima.
                    </li>
                    <li><b>Procesno orijentirani sustavi</b> - Sustavi koji prate organizacijske poslovne procese.
                    </li>
                    <li><b>Svekanalni pristup (Omnichannel) s konzistentnim korisničkim iskustvom (UX)</b> - Pristup informacijskom
                    sustavu kroz razne kanale (desktop, mobilni, web) s identičnim prezentacijama i ujednačenim korisničkim iskustvom.
                    </li>
                    <li><b>Sveobuvatna analiza podataka</b> - Klasična ili adaptivno-inteligentna analiza podataka koja  
                    omogućava pravovremeno i informirano donošenje odluka.
                    </li>
                    <li><b>Integracija modela strojnog učenja i umjetne inteligencije</b> - Korištenje modela strojnog učenja i agenata umjetne
                    inteligencije u razne svrhe, od prepoznavanja uzoraka, inteligentne automatizacije poslovnih procesa, pa sve do 
                    preporuka kod donošenja odluka.
                    </li>
                    <li><b>Adaptivnost inteligentnih modela</b> - Procesi za aktualizaciju modela strojnog učenja.
                    </li>
                    <li><b>Odgovarajuće upravljanje projektima</b> - Upravljanje projektima koje ima za cilj uspješnu implementaciju
                    informacijskog sustava, uz korištenje odgovarajuće metodologije za upravljanje projektima.
                    </li>
                </ul>
            </p>
            <p className="NonIndented"><b>Vizija Nove Inteligencije</b><br/>
                Stremiti uspješnim i kvalitetnim implementacijama informacijskih sustava uz dodane vrijednosti. Omogućiti
                transparentnu implementaciju inteligentnih komponenti i modela koji su korisni krajnjem korisniku
                i obogaćuju korisničko iskustvo. Prihvaćati nove i moderne izazove, te na taj način omogućiti vlastitim zaposlenicima
                usavršavanje i praćenje modernih trendova u informacijskim tehnologijama i znanosti. Ponuditi korisnicima
                znanstveno-istraživački rad u svrhu unaprijeđenja poslovanja. Uspjeh korisnika je i uspjeh
                Nove Inteligencije.
            </p><br/>
            <p className="NonIndented">
                <img className={"Dado"} style={{width: `18vmin`, height: `18vmin`, borderRadius: `9vmin`, zIndex: 10}} />
                <b>Osnivač društva</b><br/>
                <b>dr.sc. Dalibor Krleža</b><br/>
                IT arhitekt, IT konzultant, znanstvenik i predavač sa 25 godina iskustva u privredi, znanosti i visokom 
                obrazovanju. Tijekom karijere radio je kao stariji IT arhitekt za velike korporacije poput IBM-a. 
                U svojem porfoliu projekata u svojstvu starijeg IT arhitekta ima velike svjetske projekte digitalne 
                transformacije u telekomunikacijskoj industriji. Uz svjetsko iskustvo, ima i opsežno iskustvo rada 
                na Hrvatskom tržištu, gdje je predvodio izradu arhitektura i bio tehnički voditelj na cijelom nizu IT 
                projekata. Ima bogato iskustvo u raznim industrijama, a posebno u financijama, telekomunikacijama i 
                aeronautici. Posebno se ističe u uspješnom vođenju većih timova IT dizajnera i programera.<br/><br/>
                Kao znanstvenik ima zapažene rezultate u istraživanju naprednih algoritama i algoritama nenadziranog 
                strojnog učenja, što je rezultiralo i objavom znanstvenih članaka u časopisima visokog ranga. Tijekom 
                svog rada na Fakultetu Elektrotehnike i Računarstva pridružuje se izvođenju nastave na predmetu 
                "Baze podataka" te predavanju predmeta "Napredni algoritmi i strukture podataka". Na predmetu 
                "Napredni algoritmi i strukture podataka" sudjeluje u obnovi materijala i pisanju udžbenika.
                Inicira uvođenje novog predmeta pod nazivom "Arhitektura i razvoj inteligentnih sustava" koji se bavi 
                primijenjenim strojnim učenjem korištenjem MLops metodologije. Predmet "Arhitektura i razvoj inteligentnih 
                sustava" prvi puta je izveden na Fakultetu Elektrotehnike i Računarstva u akademskoj godini 2022./2023. kao izborni predmet.
            </p><br/>
            <p className="NonIndented">
                <b>Naziv društva:</b> Nova Inteligencija j.d.o.o.<br/>
                <b>MBS:</b> 081682880<br/>
                <b>OIB:</b> 35014811519<br/>
                <b>Sjedište:</b> Drobilina ulica I. odvojak 14, 10255 Donji Stupnik<br/>
                <b>IBAN:</b> HR6923400091111352625 kod PBZ d.d.<br/>
                <b>Email:</b> <a href="mailto:info@nova-inteligencija.hr">info@nova-inteligencija.hr</a><br/>
            </p><br/><br/>
            <p className="NonIndented">Web &copy; Nova Inteligencija</p>
        </>
    );
}